export class DashboardCard implements IDashboardCard{
  constructor(iDashboardCard: IDashboardCard) {
    this.columnSize = iDashboardCard?.columnSize || 12;
    this.headerClass = iDashboardCard?.headerClass || '';
    this.isCollapsed = iDashboardCard?.isCollapsed || false;
    this.toggleable = iDashboardCard?.toggleable || true;
    this.transitionOptions = iDashboardCard?.transitionOptions || '200ms';
  }
  columnSize: number;
  headerClass: string;
  isCollapsed: boolean;
  toggleable: boolean;
  transitionOptions: string;
}
export interface IDashboardCard {
  columnSize: number;
  headerClass: string;
  isCollapsed: boolean;
  toggleable: boolean;
  transitionOptions: string;
}
